/* ============================================================
   Nelyra — Ziyva Clone 1:1 — Front-end behaviours
   ============================================================ */
(function(){
  'use strict';
  var $ = function(sel, root){ return (root||document).querySelector(sel); };
  var $$ = function(sel, root){ return Array.prototype.slice.call((root||document).querySelectorAll(sel)); };

  /* ------------------------------------------------------------
     Burger mobile
     ------------------------------------------------------------ */
  document.addEventListener('click', function(e){
    var burger = e.target.closest('.nav-burger');
    if(burger){
      var links = $('#nav-links');
      if(links) links.classList.toggle('open');
    }
  });

  /* ------------------------------------------------------------
     Delivery estimate — "Livré entre [J+2] et [J+3]"
     ------------------------------------------------------------ */
  function formatDate(d){
    var months = ['janv.','févr.','mars','avr.','mai','juin','juil.','août','sept.','oct.','nov.','déc.'];
    return d.getDate() + ' ' + months[d.getMonth()];
  }
  function updateDeliveryDates(){
    var now = new Date();
    var min = new Date(now); min.setDate(min.getDate() + 2);
    var max = new Date(now); max.setDate(max.getDate() + 3);
    $$('[data-delivery-dates]').forEach(function(el){
      el.textContent = formatDate(min) + ' – ' + formatDate(max);
    });
  }

  /* ------------------------------------------------------------
     Social proof popup — order notifications, 5s visible, 25s cycle
     ------------------------------------------------------------ */
  function initSocialProof(){
    var popup = $('.social-proof-popup');
    if(!popup) return;

    var buyerNames = ['Lucas M.','Sarah B.','Théo R.','Chloé D.','Nathan P.','Inès K.','Adam L.','Lina F.','Hugo V.','Yasmine A.','Rayan S.','Kenza B.','Amine T.','Sofiane D.','Maxime G.','Emma L.','Jules R.','Léa M.','Nour H.','Samir B.'];
    var cities = ['Paris','Lyon','Marseille','Toulouse','Bordeaux','Nantes','Lille','Strasbourg','Nice','Montpellier','Rennes','Grenoble','Rouen','Toulon'];
    var colors = ['Noir','Vert','Rose','Blanc','Bleu','Jaune'];
    var reviewTexts = [
      {text:'Super qualité, livraison rapide !',name:'Sarah M.'},
      {text:'La veste est magnifique 😍',name:'Nathan'},
      {text:'Très satisfait, je recommande !',name:'Lucas'},
      {text:'Reçue en 3 jours, top !',name:'Lina'},
      {text:'Incroyable, je ne regrette pas !',name:'Yasmine A.'},
      {text:'La veste Brésil est dingue 🤩',name:'Hugo V.'},
      {text:'Franchement très bonne surprise',name:'Yanis'},
      {text:'Mon fils est ravi !',name:'Adam L.'}
    ];

    var photos = [];
    var data = $('#zv-reviews-data');
    if(data){
      try{
        var revs = JSON.parse(data.textContent);
        photos = revs.map(function(r){ return r.photo; }).filter(Boolean);
      } catch(e){}
    }

    var photoWrap = $('.social-proof-photo', popup);
    var photoEl = $('.social-proof-photo img', popup);
    var textEl  = $('.social-proof-text', popup);
    var nameEl  = $('.social-proof-name', popup);
    var idx = -1, timer;
    var VISIBLE_MS = 5000, CYCLE_MS = 25000;
    var isOrder = true;

    function randItem(arr){ return arr[Math.floor(Math.random() * arr.length)]; }

    function show(){
      idx = (idx + 1) % buyerNames.length;
      if(isOrder){
        var n = buyerNames[idx];
        var city = randItem(cities);
        var color = randItem(colors);
        var mins = Math.floor(Math.random() * 42) + 3;
        if(photoWrap) photoWrap.style.display = 'none';
        if(textEl) textEl.innerHTML = '<strong>' + n + '</strong> vient d\'acheter Veste Brésil (' + color + ')';
        if(nameEl) nameEl.textContent = city + ' · il y a ' + mins + ' min';
      } else {
        var rev = randItem(reviewTexts);
        if(photoWrap) photoWrap.style.display = '';
        if(photoEl && photos.length) photoEl.src = photos[idx % photos.length];
        if(textEl) textEl.innerHTML = '★★★★★ ' + rev.text;
        if(nameEl) nameEl.textContent = rev.name + ' · Achat vérifié';
      }
      isOrder = !isOrder;
      popup.classList.add('show');
      clearTimeout(timer);
      timer = setTimeout(function(){
        popup.classList.remove('show');
        setTimeout(show, CYCLE_MS - VISIBLE_MS);
      }, VISIBLE_MS);
    }
    setTimeout(show, 6000);
    var closeBtn = $('.social-proof-close', popup);
    if(closeBtn){
      closeBtn.addEventListener('click', function(){
        popup.classList.remove('show');
        clearTimeout(timer);
      });
    }
  }

  /* ------------------------------------------------------------
     Pack switcher (solo / bundle) — product page
     ------------------------------------------------------------ */
  function initPackSwitch(){
    var cards = $$('.pack-card');
    if(!cards.length) return;
    cards.forEach(function(card){
      card.addEventListener('click', function(){
        cards.forEach(function(c){ c.classList.remove('selected'); });
        card.classList.add('selected');
        var pack = card.getAttribute('data-pack');
        var solo = $('.solo-variant-group');
        var bundle = $('.bundle-variant-group');
        if(solo)   solo.style.display   = pack === 'solo'   ? '' : 'none';
        if(bundle) bundle.style.display = pack === 'bundle' ? '' : 'none';
        document.body.setAttribute('data-pack', pack);
        var ev = new CustomEvent('zv:pack', { detail: { pack: pack } });
        document.dispatchEvent(ev);
      });
    });
    var sel = $('.pack-card.selected');
    if(sel) sel.click();
  }

  /* ------------------------------------------------------------
     Color thumbs — swap gallery image + update label
     ------------------------------------------------------------ */
  function initColorThumbs(){
    var soloWrap = $('[data-solo-colors]');
    if(soloWrap){
      $$('.color-thumb', soloWrap).forEach(function(t){
        t.addEventListener('click', function(){
          $$('.color-thumb', soloWrap).forEach(function(x){ x.classList.remove('selected'); });
          t.classList.add('selected');
          var color = t.getAttribute('data-color');
          var label = $('[data-solo-color-label]');
          if(label) label.textContent = color;
          var img = $('.pv-gallery-main img');
          var src = t.querySelector('img') ? t.querySelector('img').src.replace('-mini','') : null;
          if(img && src) img.src = src;
          var pv = $('.product-view');
          if(pv) pv.setAttribute('data-color', color);
        });
      });
    }
    $$('.bundle-row').forEach(function(row){
      $$('.color-thumb', row).forEach(function(t){
        t.addEventListener('click', function(){
          $$('.color-thumb', row).forEach(function(x){ x.classList.remove('selected'); });
          t.classList.add('selected');
          var color = t.getAttribute('data-color');
          row.setAttribute('data-color', color);
          var label = $('.bundle-row-color', row);
          if(label) label.textContent = '· ' + color;
        });
      });
    });
  }

  /* ------------------------------------------------------------
     Size buttons
     ------------------------------------------------------------ */
  function initSizeButtons(){
    $$('.size-btn').forEach(function(b){
      b.addEventListener('click', function(){
        var group = b.parentElement;
        $$('.size-btn', group).forEach(function(x){ x.classList.remove('selected'); });
        b.classList.add('selected');
        var size = b.getAttribute('data-size');
        var pv = $('.product-view');
        if(pv) pv.setAttribute('data-size', size);
      });
    });
  }

  /* ------------------------------------------------------------
     Custom select (bundle size dropdown)
     ------------------------------------------------------------ */
  function initCustomSelect(){
    $$('[data-select]').forEach(function(sel){
      var trigger = $('.custom-select-trigger', sel);
      var label   = $('.custom-select-trigger-label', sel);
      var options = $$('.custom-select-option', sel);
      if(trigger){
        trigger.addEventListener('click', function(e){
          e.stopPropagation();
          var open = sel.classList.toggle('open');
          $$('[data-select].open').forEach(function(s){ if(s!==sel) s.classList.remove('open'); });
        });
      }
      options.forEach(function(o){
        o.addEventListener('click', function(){
          options.forEach(function(x){ x.classList.remove('active'); });
          o.classList.add('active');
          var v = o.getAttribute('data-value');
          if(label) label.textContent = v;
          sel.classList.remove('open');
          var row = sel.closest('.bundle-row');
          if(row) row.setAttribute('data-size', v);
        });
      });
    });
    document.addEventListener('click', function(){
      $$('[data-select].open').forEach(function(s){ s.classList.remove('open'); });
    });
  }

  /* ------------------------------------------------------------
     Size calculator — height + weight → recommended size
     ------------------------------------------------------------ */
  var SIZE_RULES = [
    { size:'XS', maxKg:58,  maxCm:162 },
    { size:'S',  maxKg:66,  maxCm:170 },
    { size:'M',  maxKg:75,  maxCm:177 },
    { size:'L',  maxKg:85,  maxCm:184 },
    { size:'XL', maxKg:95,  maxCm:190 },
    { size:'XXL',maxKg:105, maxCm:196 },
    { size:'XXXL', maxKg:999, maxCm:999 }
  ];
  function pickSize(h, w){
    var byW = SIZE_RULES.find(function(r){ return w <= r.maxKg; }) || SIZE_RULES[SIZE_RULES.length-1];
    var byH = SIZE_RULES.find(function(r){ return h <= r.maxCm; }) || SIZE_RULES[SIZE_RULES.length-1];
    var ia = SIZE_RULES.indexOf(byW), ib = SIZE_RULES.indexOf(byH);
    return SIZE_RULES[Math.max(ia, ib)].size;
  }
  function initSizeCalc(){
    $$('[data-size-guide]').forEach(function(root){
      var btn    = $('[data-calc]', root);
      var err    = $('[data-error]', root);
      var result = $('[data-result]', root);
      var badge  = $('[data-result-size]', root);
      var hIn    = $('[data-height]', root);
      var wIn    = $('[data-weight]', root);
      if(!btn) return;
      btn.addEventListener('click', function(){
        var h = parseInt(hIn.value, 10);
        var w = parseInt(wIn.value, 10);
        if(!h || !w){
          if(err) err.hidden = false;
          if(result) result.hidden = true;
          return;
        }
        if(err) err.hidden = true;
        var size = pickSize(h, w);
        if(badge) badge.textContent = size;
        if(result) result.hidden = false;
        $$('.size-guide-table tr').forEach(function(tr){ tr.classList.remove('active'); });
        var row = $('.size-guide-table tr[data-size="'+size+'"]', root);
        if(row) row.classList.add('active');
      });
    });
  }

  /* ------------------------------------------------------------
     Quantity selector
     ------------------------------------------------------------ */
  function initQuantity(){
    $$('.quantity-selector').forEach(function(sel){
      var input = $('input', sel);
      var minus = sel.querySelector('[data-qty-minus]');
      var plus  = sel.querySelector('[data-qty-plus]');
      if(minus) minus.addEventListener('click', function(){
        var v = Math.max(1, parseInt(input.value, 10) - 1);
        input.value = v;
      });
      if(plus) plus.addEventListener('click', function(){
        var v = parseInt(input.value, 10) + 1;
        input.value = v;
      });
    });
  }

  /* ------------------------------------------------------------
     Scroll to reviews — click rating line
     ------------------------------------------------------------ */
  function initScrollToReviews(){
    $$('[data-scroll-reviews]').forEach(function(el){
      el.addEventListener('click', function(){
        var target = $('.pdp-reviews');
        if(target) target.scrollIntoView({ behavior:'smooth', block:'start' });
      });
    });
  }

  /* ------------------------------------------------------------
     Cart drawer — AJAX add-to-cart + slide-out drawer
     ------------------------------------------------------------ */
  function initCartDrawer(){
    var overlay = $('.cart-drawer-overlay');
    var drawer  = $('.cart-drawer');
    if(!overlay || !drawer) return;
    if(!document.getElementById('zv-cart-props-css')){var s=document.createElement('style');s.id='zv-cart-props-css';s.textContent='.cart-drawer-item-props{margin:4px 0 6px;padding:6px 8px;background:var(--panel-2);border-radius:6px;border:1px solid var(--line)}.cart-drawer-prop{font-size:11px;color:var(--off-dim);margin:0;line-height:1.5}.cart-drawer-prop span{font-weight:600;color:var(--off)}';document.head.appendChild(s);}

    function openDrawer(){ overlay.classList.add('open'); drawer.classList.add('open'); document.body.style.overflow='hidden'; }
    function closeDrawer(){ overlay.classList.remove('open'); drawer.classList.remove('open'); document.body.style.overflow=''; }
    overlay.addEventListener('click', closeDrawer);
    var closeBtn = $('.cart-drawer-close', drawer);
    if(closeBtn) closeBtn.addEventListener('click', closeDrawer);

    function fmt(cents){ return (cents/100).toFixed(2).replace('.',',') + ' €'; }

    function renderCart(cart){
      var body = $('.cart-drawer-body', drawer);
      var footer = $('.cart-drawer-footer', drawer);
      var countBadge = $$('.nav-cart-count');
      countBadge.forEach(function(b){ b.textContent = cart.item_count; });
      var title = $('.cart-drawer-header h3', drawer);
      if(title) title.textContent = 'Panier (' + cart.item_count + ')';
      if(!cart.items.length){
        body.innerHTML = '<div class="cart-drawer-empty">Votre panier est vide.</div>';
        footer.style.display = 'none';
        return;
      }
      footer.style.display = '';
      var html = '';
      cart.items.forEach(function(item){
        html += '<div class="cart-drawer-item" data-key="'+item.key+'">';
        html += '<div class="cart-drawer-item-img"><img src="'+(item.image||'')+'" alt=""></div>';
        html += '<div class="cart-drawer-item-info">';
        html += '<p class="cart-drawer-item-title">'+item.product_title+'</p>';
        html += '<p class="cart-drawer-item-variant">'+item.variant_title+'</p>';
        if(item.properties&&Object.keys(item.properties).length){
          html+='<div class="cart-drawer-item-props">';
          Object.keys(item.properties).forEach(function(k){
            if(k.charAt(0)==='_') return;
            html+='<p class="cart-drawer-prop"><span>'+k+':</span> '+item.properties[k]+'</p>';
          });
          html+='</div>';
        }
        html += '<p class="cart-drawer-item-price">'+fmt(item.final_line_price)+'</p>';
        html += '<div class="cart-drawer-item-row">';
        html += '<span class="cart-drawer-qty"><button data-dq="-1" aria-label="Moins">−</button><input type="number" value="'+item.quantity+'" min="1" readonly><button data-dq="1" aria-label="Plus">+</button></span>';
        html += '<button class="cart-drawer-remove" data-remove aria-label="Supprimer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6z"/></svg></button>';
        html += '</div></div></div>';
      });
      body.innerHTML = html;
      var totalEl = $('.cart-drawer-total span:last-child', drawer);
      if(totalEl) totalEl.textContent = fmt(cart.total_price);

      $$('[data-dq]', body).forEach(function(btn){
        btn.addEventListener('click', function(){
          var item = btn.closest('.cart-drawer-item');
          var key = item.getAttribute('data-key');
          var input = $('input', item);
          var newQty = Math.max(0, parseInt(input.value,10) + parseInt(btn.getAttribute('data-dq'),10));
          fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:newQty})})
            .then(function(r){return r.json()}).then(renderCart);
        });
      });
      $$('[data-remove]', body).forEach(function(btn){
        btn.addEventListener('click', function(){
          var key = btn.closest('.cart-drawer-item').getAttribute('data-key');
          fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:0})})
            .then(function(r){return r.json()}).then(renderCart);
        });
      });
    }

    var form = $('#zv-add-to-cart-form');
    if(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var variantId = form.querySelector('[data-variant-id]').value;
        var qty = parseInt(form.querySelector('[name="quantity"]').value,10) || 1;
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(variantId,10),quantity:qty})})
          .then(function(r){return r.json()})
          .then(function(){
            return fetch('/cart.js').then(function(r){return r.json()});
          })
          .then(function(cart){ renderCart(cart); openDrawer(); });
      });
    }

    $$('.nav-cart-link').forEach(function(link){
      link.addEventListener('click', function(e){
        e.preventDefault();
        fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){ renderCart(cart); openDrawer(); });
      });
    });
  }

  /* ------------------------------------------------------------
     Video stock — play/pause
     ------------------------------------------------------------ */
  function initVideoStock(){
    var overlay = $('#zv-video-overlay');
    var video = $('#zv-main-video');
    if(overlay && video){
      overlay.addEventListener('click', function(){ video.play(); overlay.classList.add('is-hidden'); });
      video.addEventListener('click', function(){ if(video.paused) video.play(); else video.pause(); });
    }
  }

  /* ------------------------------------------------------------
     Boot
     ------------------------------------------------------------ */
  function boot(){
    updateDeliveryDates();
    initSocialProof();
    initPackSwitch();
    initColorThumbs();
    initSizeButtons();
    initCustomSelect();
    initSizeCalc();
    initQuantity();
    initScrollToReviews();
    initCartDrawer();
    initVideoStock();
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
